import { campaignTagsEnum } from "../types/placement"

export const PLACEMENTS_COUNT = 5

export const COLORS_BY_TAG: Record<campaignTagsEnum, string> = {
  [campaignTagsEnum.RANKING]: "green",
}
